module.exports = __webpack_public_path__ + "media/click_on_belt.2d984964.mp3";